<script setup lang="ts">
/**
 * CuriosityGapsList — lista de até 3 lacunas. Sem contadores (CC-01).
 */
import type { CuriosityGap } from "../types";

interface Props {
  gaps: readonly CuriosityGap[];
  /** Máximo permitido (exibido para o usuário como contexto, sem pressão). */
  max: number;
}

defineProps<Props>();
</script>

<template>
  <section class="hlos-curiosity-gaps" data-testid="curiosity-gaps-list">
    <header>
      <h4>Lacunas em aberto</h4>
      <small>{{ gaps.length }} de {{ max }}</small>
    </header>
    <ul v-if="gaps.length > 0">
      <li v-for="gap in gaps" :key="gap.id" :data-domain="gap.domain">
        <strong>{{ gap.domain }}</strong>
        <span> profundidade {{ Math.round(gap.kaDepth * 100) }}%</span>
      </li>
    </ul>
    <p v-else>Nenhuma lacuna ativa no momento.</p>
  </section>
</template>

<style scoped>
.hlos-curiosity-gaps {
  padding: 0.75rem 0;
}
header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 0.5rem;
}
h4 {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
}
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
li {
  padding: 0.25rem 0;
  opacity: 0.9;
}
li strong {
  font-family: ui-monospace, monospace;
  font-size: 0.85em;
}
</style>
